import moment from "moment";

export const convertDateIntoEpochUTC = (date: string): number => {
  try {
    return moment.utc(date).valueOf();
  } catch {
    return 0;
  }
};
